import AvatarImage from '../../ui/AvatarImage';
import Table from '../../ui/Table';
import Tag from '../../ui/Tag';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import InviteMemberModal from './InviteMemberModal';
import StatsCard from '../../ui/StatsCard';
import WhiteCard from '../../ui/WhiteCard';
import { useEffect, useState } from 'react';
import { getOrganizationMembers, getOrganizationMembersCount } from '../../apis/oragnisations/organisation';
import Pagination from '../../ui/Pagination';
import { Connection } from '@solana/web3.js';
import { clusterApiUrl } from '@solana/web3.js';
import { executorToFetchThreshold } from '../../blockchainInteraction/fetchThreshold';
import { useLoadingState } from '../../hooks/useLoader';
import Loader from '../../ui/Loader';
import NoDataAvailable from '../../ui/NoDataAvailable';
import { RPC_ENDPOINT } from '../../constants/apiPaths';
import TruncatedTextWithTooltip from '../../ui/TruncatedTextWithTooltip';

function MembersAndRolesList() {
    const [particularOrg, _, roles] = useOutletContext();
    const [orgMembers, setOrgMembers] = useState([]);
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [treasurerThreshold, setTreasurerThreshold] = useState(0);
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const { treasurerMultisig } = particularOrg;
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startLoading();
                    const countData = await getOrganizationMembersCount(id);
                    setTotalEntries(countData?.entryCount || 0);
                    const [response1] = await Promise.all([getOrganizationMembers(id, currentPage, entriesPerPage)]);

                    setOrgMembers(response1);
                    stopLoading();
                } catch (error) {
                    console.error(error, 'erroe');
                }
            };

            const onExecution = async () => {
                const connection = new Connection(RPC_ENDPOINT, 'confirmed');

                try {
                    const fetchedThreshold = await executorToFetchThreshold(treasurerMultisig, connection);

                    setTreasurerThreshold(fetchedThreshold);
                } catch (error) {
                    console.log(error);
                }
            };

            fetchData();
            if (treasurerMultisig) onExecution();
        },
        [id, currentPage, entriesPerPage]
    );

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
        setCurrentPage(1);
    };
    let relativeAddress = location.pathname.split('/');
    relativeAddress.pop();
    relativeAddress = relativeAddress.join('/');
    const isAdmin = roles.includes('isAdmin');

    const initialCount = { totalMembers: orgMembers.length, bountyManagers: 0, bountyValidators: 0, treasurer: 0 };
    const membersCount = orgMembers.reduce((acc, item, index) => {
        return {
            ...acc,
            bountyManagers: item.isBountyManager ? acc.bountyManagers + 1 : acc.bountyManagers,
            bountyValidators: item.isBountyValidator ? acc.bountyValidators + 1 : acc.bountyValidators,
            treasurer: item.isTreasurer ? acc.treasurer + 1 : acc.treasurer,
        };
    }, initialCount);

    const adminFirstOrgMembers = [
        ...orgMembers.filter((member) => member.isAdmin),
        ...orgMembers.filter((member) => !member.isAdmin),
    ];

    return (
        <div>
            <WhiteCard className="w-fit p-6 flex gap-6 border border-borderUnderline">
                <StatsCard countHeading={'Total Members'} count={membersCount.totalMembers} />
                <StatsCard countHeading={'Bounty Managers'} count={membersCount.bountyManagers} />
                <StatsCard countHeading={'Bounty Validators'} count={membersCount.bountyValidators} />
                {/* <StatsCard countHeading={'Treasurer'} count={membersCount.treasurer} /> */}
            </WhiteCard>
            {/* <WhiteCard className="flex p-6 font-semibold text-textPrimary gap-1 w-fit ">
                <p>Treasury Threshold:</p>
                <p>{treasurerThreshold}</p>
            </WhiteCard> */}

            <Table className="gap-4">
                {isAdmin && (
                    <Table.Description
                        description="Members & Roles"
                        secondaryBtn="Edit Members & Roles"
                        tertiaryBtn="Invitations/Requests"
                        primaryBtnModal="+ Add Member"
                        clickOnPrimary={() => {
                            navigate(`${relativeAddress}/add-member`);
                        }}
                        clickOnTertiary={() => navigate(`invitations`)}
                        clickOnSecondary={() => navigate(`${relativeAddress}/edit-member`)}
                        modalNeedToOpen={<InviteMemberModal orgMembers={orgMembers} />}
                    />
                )}
                <Table.Header>
                    <p className="text-sm font-semibold text-textSecondary ">Citizen ID</p>
                    <p className="text-sm font-semibold text-textSecondary ">Member Username</p>
                    <p className="text-sm  font-semibold text-textSecondary ">Roles</p>
                </Table.Header>
                {!loading ? (
                    adminFirstOrgMembers.length > 0 ? (
                        adminFirstOrgMembers.map((member, index) => {
                            return (
                                <Table.Row key={member.uid + index + Math.random()}>
                                    <TruncatedTextWithTooltip
                                        containerClassName={'self-center'}
                                        textClassName="text-textSecondary"
                                        text={member.uid}
                                    />
                                    <div className="flex items-center gap-1 ">
                                        <AvatarImage w="w-8" h="h-8" url={member.profileImage} />
                                        <p className="text-textPrimary font-medium ">{member.userName}</p>
                                    </div>

                                    <div className="flex items-center   gap-[10px] ">
                                        <>
                                            {member.isAdmin && (
                                                <Tag
                                                    rounded="rounded-lg "
                                                    className="px-2 py-1 leading-3   "
                                                    textClassName="text-xs font-semibold"
                                                    bg="bg-tagPurpleBg"
                                                    textColor="text-tagPurpleText"
                                                    text={'Admin'}
                                                />
                                            )}
                                            {member.isBountyValidator && (
                                                <Tag
                                                    rounded="rounded-lg "
                                                    className="px-2 py-1 leading-3   "
                                                    textClassName="text-xs font-semibold"
                                                    bg="bg-tagGreenBg"
                                                    textColor="text-tagGreenText"
                                                    text={'Validator'}
                                                />
                                            )}
                                            {member.isBountyManager && (
                                                <Tag
                                                    rounded="rounded-lg"
                                                    className="px-2 py-1 leading-3   "
                                                    textClassName="text-xs font-semibold"
                                                    bg="bg-tagRedBg"
                                                    textColor="text-tagRedText"
                                                    text={'Bounty Manager'}
                                                />
                                            )}
                                            {/* {member.isTreasurer && (
                                                <Tag
                                                    rounded="rounded-lg"
                                                    className="px-2 py-1 leading-3   "
                                                    textClassName="text-xs font-semibold"
                                                    bg="bg-treasurerBg"
                                                    textColor="text-treasurerText"
                                                    text={'Treasurer'}
                                                />
                                            )} */}
                                        </>
                                    </div>
                                </Table.Row>
                            );
                        })
                    ) : (
                        <NoDataAvailable />
                    )
                ) : (
                    <div className="min-h-[20vh] flex justify-center items-center">
                        <Loader />
                    </div>
                )}
                {totalEntries > 10 && (
                    <div className="w-[100%] mx-auto">
                        <Pagination
                            className="pt-6 pb-[.65rem]"
                            hoverColor="hover:text-textPrimary"
                            currentColor="bg-neutral50D"
                            textActive="text-textPrimary"
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalEntries / entriesPerPage)}
                            entriesPerPage={entriesPerPage}
                            totalEntries={totalEntries}
                            entriesHandler={entriesHandler}
                            onPageChange={setCurrentPage}
                            border="border-borderUnderline"
                            hoverBorder="hover:border-borderUnderline"
                        />
                    </div>
                )}
            </Table>
        </div>
    );
}

export default MembersAndRolesList;
